import { Chip } from "@mui/material";
import { useTranslate } from "react-admin";
import CustomFilterText from "../unit/CustomFilterText";

const QuickFilter = ({
  label,
}: {
  label: string;
  source?: string;
  defaultValue?: any;
}) => {
  const translate = useTranslate();
  return <Chip sx={{ marginBottom: 1 }} label={translate(label)} />;
};

export const getProductListFilter = () => [
  <CustomFilterText label="ID" source="id" defaultValue="" />,
  <CustomFilterText label="Product" source="sProductName" defaultValue="" />,
];
